<div class="modal-header px-4" *ngIf="keyBoardEvent === 'CRONLIST'">
  <h4 class="modal-title" id="modal-basic-title">cron expression</h4>
  <button type="button" class="close pt-4" aria-label="Close" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" *ngIf="keyBoardEvent === 'CRONLIST'">
  <div class="panel panel-default">
    <div class="panel-heading font-bold text-uppercase">The cron expression must be of 6 digit format. Please find the
      description and samples below :</div>
    <div class="panel-body">
      <div class="alert alert-warning font-bold">Ex. * * * ? * *</div>
      <ol class="list-group">
        <li class="list-group-item">1. First placeholder is for second i.e. 0 or * .</li>
        <li class="list-group-item">2. Second placeholder is for minute i.e. * or */2 or 1/2 or */5 or */10.</li>
        <li class="list-group-item">3. Third placeholder is for hour i.e. * or */2 or 0/2 or 1/2 or */6.</li>
        <li class="list-group-item">4. Fourth placeholder is for day of the month i.e. */7 or 2 or LW or 1W.</li>
        <li class="list-group-item">5. Fifth placeholder is for month of the year i.e. JAN or JAN,JUN or 9-12.</li>
        <li class="list-group-item">6. Sixth placeholder is for day of the week i.e. MON or MON-FRI or SUN,SAT.</li>
      </ol>

      <div class="alert alert-success">NOTE : 1. One of the values at 4th and 6th placeholders must be "?" if provided
        the other with some value or "*".</div>
    </div>
  </div>
  <h3 class="text-uppercase">Examples</h3>
  <div class="alert alert-warning">NOTE : The given examples schedule the executions at the next whole day, hour, minute
    or second. For executions at a particular
    time please change the cron expressions accordingly.
  </div>
  <div class="table-responsive">
    <table class="table table-condensed">
      <tr class="active">
        <th>Cron Expression</th>
        <th>Description</th>
        <th>Cron Expression</th>
        <th>Description</th>
      </tr>
      <tr>
        <td class="font-bold">* * * ? * * </td>
        <td>Every second</td>

        <td class="font-bold">0 * * ? * * </td>
        <td>Every minute</td>
      </tr>
      <tr>
        <td class="font-bold">0 */2 * ? * * </td>
        <td>Every even minute</td>

        <td class="font-bold">0 1/2 * ? * * </td>
        <td>Every uneven minute</td>
      </tr>
      <tr>
        <td class="font-bold">0 */2 * ? * * </td>
        <td>Every 2 minutes</td>

        <td class="font-bold">0 */3 * ? * * </td>
        <td>Every 3 minutes</td>
      </tr>
      <tr>
        <td class="font-bold">0 */4 * ? * * </td>
        <td>Every 4 minutes</td>

        <td class="font-bold">0 */5 * ? * * </td>
        <td>Every 5 minutes</td>
      </tr>
      <tr>
        <td class="font-bold">0 */10 * ? * * </td>
        <td>Every 10 minutes</td>

        <td class="font-bold">0 */15 * ? * * </td>
        <td>Every 15 minutes</td>
      </tr>
      <tr>
        <td class="font-bold">0 */30 * ? * * </td>
        <td>Every 30 minutes</td>

        <td class="font-bold">0 15,30,45 * ? * * </td>
        <td>Every hour at minutes 15, 30 and 45</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 * ? * * </td>
        <td>Every hour</td>

        <td class="font-bold">0 0 0/2 ? * * </td>
        <td>Every even hour</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 1/2 ? * * </td>
        <td>Every uneven hour</td>

        <td class="font-bold">0 0 */3 ? * * </td>
        <td>Every three hours</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 */4 ? * * </td>
        <td>Every four hours</td>

        <td class="font-bold">0 0 */6 ? * * </td>
        <td>Every six hours</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 */8 ? * * </td>
        <td>Every eight hours</td>

        <td class="font-bold">0 0 */12 ? * * </td>
        <td>Every twelve hours</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 0 * * ? </td>
        <td>Every day at midnight - 12am</td>

        <td class="font-bold">0 0 1 * * ? </td>
        <td>Every day at 1am</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 6 * * ? </td>
        <td>Every day at 6am</td>

        <td class="font-bold">0 0 12 * * ? </td>
        <td>Every day at noon - 12pm</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * SUN </td>
        <td>Every Sunday at noon</td>

        <td class="font-bold">0 0 12 ? * MON </td>
        <td>Every Monday at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * TUE </td>
        <td>Every Tuesday at noon</td>

        <td class="font-bold">0 0 12 ? * WED </td>
        <td>Every Wednesday at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * THU </td>
        <td>Every Thursday at noon</td>

        <td class="font-bold">0 0 12 ? * FRI </td>
        <td>Every Friday at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * SAT </td>
        <td>Every Saturday at noon</td>

        <td class="font-bold">0 0 12 ? * MON-FRI </td>
        <td>Every Weekday at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * SUN,SAT </td>
        <td>Every Saturday and Sunday at noon</td>

        <td class="font-bold">0 0 12 */7 * ? </td>
        <td>Every 7 days at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 1 * ? </td>
        <td>Every month on the 1st, at noon</td>

        <td class="font-bold">0 0 12 2 * ? </td>
        <td>Every month on the 2nd, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 15 * ? </td>
        <td>Every month on the 15th, at noon</td>

        <td class="font-bold">0 0 12 1/2 * ? </td>
        <td>Every 2 months on the 1st, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 1/4 * ? </td>
        <td>Every 4 months on the 1st, at noon</td>

        <td class="font-bold">0 0 12 L * ? </td>
        <td>Every month on the last day of the month, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 L-2 * ? </td>
        <td>Every month on the second to last day of the month, at noon</td>

        <td class="font-bold">0 0 12 LW * ? </td>
        <td>Every month on the last weekday, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 1L * ? </td>
        <td>Every month on the last Sunday, at noon</td>

        <td class="font-bold">0 0 12 2L * ? </td>
        <td>Every month on the last Monday, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 6L * ? </td>
        <td>Every month on the last Friday, at noon</td>

        <td class="font-bold">0 0 12 1W * ? </td>
        <td>Every month on the nearest Weekday to the 1st of the month, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 15W * ? </td>
        <td>Every month on the nearest Weekday to the 15th of the month, at noon</td>

        <td class="font-bold">0 0 12 ? * 2#1 </td>
        <td>Every month on the first Monday of the Month, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * 6#1 </td>
        <td>Every month on the first Friday of the Month, at noon</td>

        <td class="font-bold">0 0 12 ? * 2#2 </td>
        <td>Every month on the second Monday of the Month, at noon</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? * 5#3 </td>
        <td>Every month on the third Thursday of the Month, at noon - 12pm</td>

        <td class="font-bold">0 0 12 ? JAN * </td>
        <td>Every day at noon in January only</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? JUN * </td>
        <td>Every day at noon in June only</td>

        <td class="font-bold">0 0 12 ? JAN,JUN * </td>
        <td>Every day at noon in January and June</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? DEC * </td>
        <td>Every day at noon in December only</td>

        <td class="font-bold">0 0 12 ? JAN,FEB,MAR,APR * </td>
        <td>Every day at noon in January, February, March and April</td>
      </tr>
      <tr>
        <td class="font-bold">0 0 12 ? 9-12 * </td>
        <td>Every day at noon between September and December</td>
        <td></td>
        <td></td>
      </tr>
    </table>
  </div>
</div>

<div class="modal-header px-4" *ngIf="keyBoardEvent !== 'CRONLIST'">
  <h4 class="modal-title" id="modal-basic-title">Example Keys</h4>
  <button type="button" class="close pt-4" aria-label="Close" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="keyBoardEvent === 'DOWN' || keyBoardEvent === 'UP' || keyBoardEvent === 'PRESS'">
  <div class="panel panel-default">
    <div class="panel-heading panel-keytype font-bold text-uppercase">Keyboard Event - {{keyBoardEvent}}</div>
    <div class="panel-body">
      <div class="alert alert-warning font-bold">
        <div style="color: chocolate; font-size: 15px" class="mb-1">Examples of the keys are:</div> 
        <div style="color:darkslategray" class="mb-1"> F1 - F12, Digit0 - Digit9, KeyA - KeyZ, Backquote,
          Minus, Equal, Backslash, Backspace, Tab, Delete, Escape, ArrowDown,</div>
          <div style="color:darkslategray">End, Enter, Home, Insert, PageDown, PageUp, ArrowRight, ArrowUp, etc.</div>
      </div>
      <ol class="list-group">
        <li class="list-group-item">1. Following modification shortcuts are also supported: Shift, Control, Alt, Meta,
          ShiftLeft, ControlOrMeta. ControlOrMeta resolves to Control on Windows and Linux and to Meta on macOS.</li>
        <li class="list-group-item">2. Holding down Shift will type the text that corresponds to the key in the upper
          case.</li>
        <li class="list-group-item">3. If key is a single character, it is case-sensitive, so the values a and A will
          generate different respective texts.</li>
        <li class="list-group-item" *ngIf="keyBoardEvent === 'DOWN' || keyBoardEvent === 'UP'">4. If key is a modifier key, Shift, Meta, Control, or Alt, subsequent key presses
          will be sent with that modifier active. To release the modifier key, use keyboard.up().</li>
          <li class="list-group-item" *ngIf="keyBoardEvent === 'PRESS'">4. Shortcuts such as key: "Control+o", key: "Control++ or key: "Control+Shift+T" are supported as well. When specified with the modifier, modifier is pressed and being held while the subsequent key is being pressed.</li>
      </ol>
    </div>
  </div>
</div>

<div class="modal-body" *ngIf="keyBoardEvent === 'TYPE'">
  <div class="panel panel-default">
    <div class="panel-heading font-bold text-uppercase panel-keytype">Keyboard Event - {{keyBoardEvent}}</div>
    <div class="panel-body">
      <div class="alert alert-warning font-bold">
        <div style="color: chocolate; font-size: 15px" class="mb-1">Examples of the keys are: </div>
        <div style="color:darkslategray">Digit0 - Digit9, KeyA - KeyZ, Backquote, Minus, Equal, Backslash etc.</div>
      </div>
      <ol class="list-group">
        <li class="list-group-item">1. Simulates typing into an input field. Can be any key on the keyboard.</li>
      </ol>
    </div>
  </div>
</div>